export default __webpack_public_path__ + "static/media/21.84d0c993.jpg";